import React from "react";
import {Table} from "react-bootstrap";

export default ({notifications}) => {
    if (!notifications?.length) {
        return <p>Уведомлений нет</p>;
    }

    return (
        <Table>
            <thead>
            <tr>
                <th>Сообщение</th>
                <th style={{width: 80}}>Переходы</th>
            </tr>
            </thead>
            <tbody>
            {notifications.map((notification) =>
                <tr key={notification.id}>
                    <td>{notification.name}</td>
                    <td>{notification.click}</td>
                </tr>
            )}
            </tbody>
        </Table>
    );
}
